import { Routes, Route, RoutesProps } from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ProtectedRoute from "./ProtectedRoute";
import Setting from "../components/Settings/Setting";
import { AccessDenied } from "../components/Common/AccessDenied/AccessDenied";
import AdGroups from "../components/AmazonAds/Campaigns/AdGroups";
const Main = React.lazy(() => import("../components/Main"));
const AuthRedirect = React.lazy(
  () => import("../components/AuthRedirect/AuthRedirect"),
);
const Profile = React.lazy(() => import("../components/Profile/Profile"));
const Brands = React.lazy(() => import("../components/Brands/Brands"));
const TeamMember = React.lazy(
  () => import("../components/TeamMember/TeamMember"),
);
const AddBrand = React.lazy(
  () => import("../components/Brands/AddBrand/AddBrand"),
);
const MySubscription = React.lazy(
  () => import("../components/Subscription/Subscription"),
);

const AmazonMain = React.lazy(
  () => import("../components/AmazonAds/AmazonMain"),
);
const AmazonAds = React.lazy(() => import("../components/AmazonAds/AmazonAds"));
const AuditLogs = React.lazy(
  () => import("../components/AmazonAds/AuditLogs/AuditLogs"),
);
const SearchTerm = React.lazy(
  () => import("../components/Reports/SearchTearm/SearchTerms"),
);
const SPPlacementReport = React.lazy(
  () => import("../components/AmazonAds/Campaigns/Common/placements"),
);
const SPAutoTargetReport = React.lazy(
  () => import("../components/AmazonAds/Campaigns/Common/Targeting"),
);
const SBPlacementReport = React.lazy(
  () => import("../components/AmazonAds/Campaigns/Common/SBPlacements"),
);
const CampaignReport = React.lazy(
  () => import("../components/Reports/Campaign/Campaign"),
);
const Keywords = React.lazy(() => import("../components/Keywords/Keywords"));

const Heatmaps = React.lazy(() => import("../components/Heatmaps/Heatmaps"));

const AccountRedirect = React.lazy(
  () =>
    import("../components/MarketingInsights/AccountRedirect/AccountRedirect"),
);
const Budget = React.lazy(() => import("../pages/Budget/Budget"));

const CampaignDetails = React.lazy(
  () => import("../components/AmazonAds/Campaigns/CampaignDetails"),
);

const AdsDetails = React.lazy(
  () => import("../components/AmazonAds/Campaigns/AdsDetails"),
);
const ConnectedChannels = React.lazy(
  () =>
    import("../components/MarketingInsights/CampaignsPerformance/ConnectedChannels/ConnectedChannels"),
);
const AddProductStep1 = React.lazy(
  () => import("../components/AmazonAds/Products/AddProduct/Step1"),
);
const AddProductStep2 = React.lazy(
  () => import("../components/AmazonAds/Products/AddProduct/Step2"),
);
const AddCampaignSteps = React.lazy(
  () => import("../components/AmazonAds/Campaigns/AddCampaign/Steps"),
);
const AddCampaign = React.lazy(
  () => import("../components/AmazonAds/Campaigns/AddCampaign/AddCampaign"),
);

const SDCreate = React.lazy(
  () => import("../components/AmazonAds/Campaigns/CreateCampaign/sd/SDCreate"),
);

const SBCreate = React.lazy(
  () => import("../components/AmazonAds/Campaigns/CreateCampaign/sb/SBCreate"),
);

const Accounts = React.lazy(
  () => import("../components/MainAccounts/MainAccounts"),
);

const WalmartAccounts = React.lazy(
  () => import("../components/WalmartAccounts/WalmartAccounts"),
);

const PortfolioList = React.lazy(
  () => import("../components/AmazonAccounts/Portfolio/PortfolioList"),
);

const WalmartPortfolioList = React.lazy(
  () => import("../components/WalmartAccounts/Portfolio/Portfolio"),
);

const ProductReport = React.lazy(
  () => import("../components/Reports/Product/ProductPage"),
);

const Products = React.lazy(
  () => import("../components/Reports/Product/Products"),
);


const Login = React.lazy(() => import("../components/Login/Login"));

const Register = React.lazy(() => import("../components/Login/Register"));

const ForgotPassword = React.lazy(
  () => import("../components/Login/ForgotPassword"),
);

const ResetPassword = React.lazy(
  () => import("../components/Login/ResetPassword"),
);

const BrandInvitation = React.lazy(
  () => import("../components/Brands/BrandInvitation"),
);

const SBProductAds = React.lazy(
  () => import("../components/Reports/Product/SBProductAds"),
);

const Recommendations = React.lazy(
  () => import("../components/Recommendations/Recommendations"),
);

const WalmartMain = React.lazy(
  () => import("../components/WalmartAds/WalmartMain"),
);

const WalmartAds = React.lazy(
  () => import("../components/WalmartAds/WalmartAds"),
);

const WalmartCampaignDetails = React.lazy(
  () => import("../components/WalmartAds/Campaigns/CampaignDetails"),
);

const WalmartAdGroups = React.lazy(
  () => import("../components/WalmartAds/Campaigns/WalmartAdGroups"),
);

const WalmartAddCampaign = React.lazy(
  () => import("../components/WalmartAds/Campaigns/AddCampaign/AddCampaign"),
);

const WalmartAdsDetails = React.lazy(
  () => import("../components/WalmartAds/Campaigns/WalmartAdsDetails"),
);

const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard"));

const AutoLogin = React.lazy(() => import("../components/Login/AutoLogin"));

const AmazonDashboard = React.lazy(
  () => import("../components/AmazonAds/Dashboard/AmazonDashboard"),
);

const HourlyPerformance = React.lazy(
  () =>
    import("../components/AmazonAds/Hourly Performancepage/Hourlyperformancepage"),
);

const Navigation = () => {
  useEffect(() => {}, []);

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="/auth/redirect"
            element={
              <Suspense fallback={<></>}>
                <AutoLogin />
              </Suspense>
            }
          />
          <Route
            path="/register"
            element={
              <Suspense fallback={<></>}>
                <Register />
              </Suspense>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <Suspense fallback={<></>}>
                <ForgotPassword />
              </Suspense>
            }
          />
          <Route
            path="/reset-password/:token"
            element={
              <Suspense fallback={<></>}>
                <ResetPassword />
              </Suspense>
            }
          />
          <Route
            path="/auth/redirect"
            element={
              <Suspense fallback={<></>}>
                <AuthRedirect />
              </Suspense>
            }
          />
          <Route
            path="/setup"
            element={
              <Suspense fallback={<></>}>
                <AddBrand />
              </Suspense>
            }
          />
          <Route
            path="/invitation"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    <BrandInvitation />
                  </Suspense>
                }
              />
            }
          />
          <Route
            path="/accounts"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    <Accounts />
                  </Suspense>
                }
              />
            }
          />

          <Route
            path="/walmart-accounts"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    <WalmartAccounts />
                  </Suspense>
                }
              />
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    <Main />
                  </Suspense>
                }
              />
            }
          >
            <Route
              path="/profile"
              element={
                <Suspense fallback={<></>}>
                  <Profile />
                </Suspense>
              }
            />
            <Route
              path="/my-brand"
              element={
                <Suspense fallback={<></>}>
                  <Brands />
                </Suspense>
              }
            />
            <Route
              path="/team"
              element={
                <Suspense fallback={<></>}>
                  <TeamMember />
                </Suspense>
              }
            />
            <Route
              path="/my-subscription"
              element={
                <Suspense fallback={<></>}>
                  <MySubscription />
                </Suspense>
              }
            />
            <Route
              path="/setting"
              element={
                <Suspense fallback={<></>}>
                  <Setting />
                </Suspense>
              }
            />

            <Route
              path="/access-denied"
              element={
                <Suspense fallback={<></>}>
                  <AccessDenied />
                </Suspense>
              }
            />
            <Route
              path="connected-channels"
              element={
                <Suspense fallback={<></>}>
                  <ConnectedChannels />
                </Suspense>
              }
            />
            <Route
              path="campaign-report"
              element={
                <Suspense fallback={<></>}>
                  <CampaignReport />
                </Suspense>
              }
            />

            <Route
              path="/"
              element={
                <Suspense fallback={<></>}>
                  <AmazonMain />
                </Suspense>
              }
            >
              <Route
                path="/heatmaps"
                element={
                  <Suspense fallback={<></>}>
                    <Heatmaps />
                  </Suspense>
                }
              />
              <Route
                path="amazonads"
                element={
                  <Suspense fallback={<></>}>
                    <AmazonAds />
                  </Suspense>
                }
              />
              <Route
                path="audit-logs"
                element={
                  <Suspense fallback={<></>}>
                    <AuditLogs />
                  </Suspense>
                }
              />
              <Route
                path="ad-groups"
                element={
                  <Suspense fallback={<></>}>
                    <AdGroups />
                  </Suspense>
                }
              />
              <Route
                path="product-report"
                element={
                  <Suspense fallback={<></>}>
                    <ProductReport />
                  </Suspense>
                }
              />
              <Route
                path="products"
                element={
                  <Suspense fallback={<></>}>
                    <Products />
                  </Suspense>
                }
              />
              <Route
                path="campaign-details/:id"
                element={
                  <Suspense fallback={<></>}>
                    <CampaignDetails />
                  </Suspense>
                }
              />
              <Route
                path="ad-group-details"
                element={
                  <Suspense fallback={<></>}>
                    <AdsDetails />
                  </Suspense>
                }
              />
              <Route
                path="ad-group-details/:id"
                element={
                  <Suspense fallback={<></>}>
                    <AdsDetails />
                  </Suspense>
                }
              />

              <Route
                path="budget"
                element={
                  <Suspense fallback={<></>}>
                    <Budget />
                  </Suspense>
                }
              />
              <Route
                path="keywords"
                element={
                  <Suspense fallback={<></>}>
                    <Keywords />
                  </Suspense>
                }
              />
              <Route
                path="search-term"
                element={
                  <Suspense fallback={<></>}>
                    <SearchTerm />
                  </Suspense>
                }
              />
              <Route
                path="sp-placement-report"
                element={
                  <Suspense fallback={<></>}>
                    <SPPlacementReport ctype="ALL" />
                  </Suspense>
                }
              />
              <Route
                path="auto-target-report"
                element={
                  <Suspense fallback={<></>}>
                    <SPAutoTargetReport target_type="SP_TARGET" type="AUTO" />
                  </Suspense>
                }
              />
              <Route
                path="targeting-report"
                element={
                  <Suspense fallback={<></>}>
                    <SPAutoTargetReport target_type="" type="MANUAL" />
                  </Suspense>
                }
              />
              <Route
                path="sb-product-ads"
                element={
                  <Suspense fallback={<></>}>
                    <SBProductAds />
                  </Suspense>
                }
              />
              <Route
                path="recommendations"
                element={
                  <Suspense fallback={<></>}>
                    <Recommendations />
                  </Suspense>
                }
              />

              <Route
                path="sb-placement-report"
                element={
                  <Suspense fallback={<></>}>
                    <SBPlacementReport />
                  </Suspense>
                }
              />
            </Route>

            <Route
              path="/"
              element={
                <Suspense fallback={<></>}>
                  <WalmartMain />
                </Suspense>
              }
            >
              <Route
                path="/walmartads"
                element={
                  <Suspense fallback={<></>}>
                    <WalmartAds />
                  </Suspense>
                }
              />

              <Route
                path="/walmart-adgroups"
                element={
                  <Suspense fallback={<></>}>
                    <WalmartAdGroups />
                  </Suspense>
                }
              />

              <Route
                path="/walmart-campaign-details/:id"
                element={
                  <Suspense fallback={<></>}>
                    <WalmartCampaignDetails />
                  </Suspense>
                }
              />

              <Route
                path="walmart-adgroup-details/:adGroupId/:campaignId"
                element={
                  <Suspense fallback={<></>}>
                    <WalmartAdsDetails />
                  </Suspense>
                }
              />
            </Route>

            <Route
              path="walmartads/add-campaign"
              element={
                <Suspense fallback={<></>}>
                  <WalmartAddCampaign />
                </Suspense>
              }
            />

            <Route
              path="amazonads/add-product/step1"
              element={
                <Suspense fallback={<></>}>
                  <AddProductStep1 />
                </Suspense>
              }
            />
            <Route
              path="amazonads/add-product/step2"
              element={
                <Suspense fallback={<></>}>
                  <AddProductStep2 />
                </Suspense>
              }
            />
            <Route
              path="amazonads/add-campaign"
              element={
                <Suspense fallback={<></>}>
                  <AddCampaign />
                </Suspense>
              }
            />
            <Route
              path="amazonads/add-campaign/steps"
              element={
                <Suspense fallback={<></>}>
                  <AddCampaignSteps />
                </Suspense>
              }
            />
            <Route
              path="amazonads/add-campaign/sd"
              element={
                <Suspense fallback={<></>}>
                  <SDCreate />
                </Suspense>
              }
            />
            <Route
              path="amazonads/add-campaign/sb"
              element={
                <Suspense fallback={<></>}>
                  <SBCreate />
                </Suspense>
              }
            />
            <Route
              path="amazon/oauth/redirect"
              element={
                <Suspense fallback={<></>}>
                  <AccountRedirect linkType={"AMAZON"} />
                </Suspense>
              }
            />
            <Route
              path="amazon/sp-api/oauth/redirect"
              element={
                <Suspense fallback={<></>}>
                  <AccountRedirect linkType={"AMAZON_SPAPI"} />
                </Suspense>
              }
            />
            <Route
              path="/portfolios"
              element={
                <Suspense fallback={<></>}>
                  <PortfolioList />
                </Suspense>
              }
            />
            <Route
              path="/amazon-dashboard"
              element={
                <Suspense fallback={<></>}>
                  <AmazonDashboard />
                </Suspense>
              }
            />
            {/* <Route
              path="/hourly-performance"
              element={
                <Suspense fallback={<></>}>
                  <HourlyPerformance />
                </Suspense>
              }
            /> */}
            <Route
              path="/walmart-portfolios"
              element={
                <Suspense fallback={<></>}>
                  <WalmartPortfolioList />
                </Suspense>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  <Dashboard />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
